:host {
  display: block;
}

.sc-address {
  display: block;
  position: relative;

  [hidden] {
    display: none;
  }

  &--loading {
    min-height: 230px;
  }

  sc-skeleton {
    display: block;
    margin-bottom: 1em;
  }

  &__control {
    display: block;

    > * {
      margin-bottom: var(--sc-address-column-spacing, -1px);
    }
  }

  &__collapsible {
    // Stripe-like technique: fields stay in the DOM so browser autocomplete
    // can detect and fill them, but they are visually hidden and non-interactive.
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: translateY(-8px);
    width: 100%;

    > * {
      margin-bottom: var(--sc-address-column-spacing, -1px);
    }

    &--expanded {
      opacity: 1;
      pointer-events: auto;
      position: relative;
      transform: translateY(0);
      transition: opacity 0.2s ease-in, transform 0.2s ease-in;
      z-index: var(--sc-address-collapsible-z-index, 9);
    }

    &:focus-within {
      z-index: var(--sc-address-collapsible-focus-z-index, 10);
    }
  }

  &__columns {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;

    > * {
      flex: 1;
      width: 50%;
      margin-right: var(--sc-address-column-spacing, -1px);

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
